<template>
	<div ref="searchModal" class="btn_search">
		<button type="button" class="btn_toggle" aria-label="btn_toggle" @click="onClickSearchBtn">
			<IconSearch :icon-color="Boolean(route.query.isSearchMenuOpen) && displayStore.isDesktop ? '#ff5e00' : '#fff'" />
		</button>
		<DesktopSearchMenu v-if="Boolean(route.query.isSearchMenuOpen) && displayStore.isDesktop" />
	</div>
</template>
<script setup lang="ts">
// core
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';

import IconSearch from '@/components/atom/icon/IconSearch.vue';
// store
import { useDisplayStore } from '@/stores/display';
// util
import { closeMenuModal, openMenuModal } from '@/utils/function/modalMenu';

import DesktopSearchMenu from './DesktopSearchMenu.vue';

// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();
const searchModal = ref();

// -----function-----
// 닫기 버트 클릭 시, 검색 창 닫힘 및 search 모달 오픈
const onClickSearchBtn = () => {
	if (route.query.isSearchMenuOpen) {
		closeMenuModal();
	} else {
		openMenuModal({ menu: 'Search' });
	}
};
//외부 클릭 시, 검색 창 닫힘 기능
onClickOutside(searchModal, () => {
	if (route.query.isSearchMenuOpen && displayStore.isDesktop) {
		closeMenuModal();
	}
});
</script>

<style lang="scss" scoped>
.btn_search {
	position: relative;
	.search_box {
		position: absolute;
		z-index: 85;
		background-color: var(--color-bg);
		top: 7rem;
		right: -15rem;
		display: flex;
		flex-direction: column;
		width: 37.5rem;
		border-radius: var(--border-radius-small);
		align-items: flex-end;
		gap: 1rem;
		padding: 1.6rem 2rem;
	}
	.search_box_mobile {
		position: absolute;
		z-index: 85;
		background-color: var(--color-bg);
		top: 7rem;
		right: -5.5rem;
		display: flex;
		flex-direction: column;
		width: 37.5rem;
		border-radius: var(--border-radius-small);
		align-items: flex-end;
		gap: 1rem;
		padding: 1.6rem 2rem;
	}
}
</style>
